import { render, staticRenderFns } from "./AnimatedArrow.vue?vue&type=template&id=b475f5fe&scoped=true"
import script from "./AnimatedArrow.vue?vue&type=script&lang=js"
export * from "./AnimatedArrow.vue?vue&type=script&lang=js"
import style0 from "./AnimatedArrow.vue?vue&type=style&index=0&id=b475f5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b475f5fe",
  null
  
)

export default component.exports